/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StorageChecker } from '../models/StorageChecker';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StorageCheckerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a StorageChecker resource.
     * Retrieves a StorageChecker resource.
     * @returns StorageChecker StorageChecker resource
     * @throws ApiError
     */
    public apiInternalcheckStorageGet(): CancelablePromise<StorageChecker> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/_internal/check-storage',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
